// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

/**
 * The placeholder tenant id used by demo data and stub settings. The API
 * rejects it (403 tenant_access_denied, reason stub-tenant-current), so a
 * request carrying it is always a bug: the caller ran before the workspace
 * tenant resolved (issue 874).
 */
export const PLACEHOLDER_TENANT_ID = "tenant-current";

export const TENANT_NOT_RESOLVED_MESSAGE =
  "Something went wrong loading your workspace. Try again.";

export function isPlaceholderTenantId(tenantId: string | null | undefined): boolean {
  return tenantId?.trim() === PLACEHOLDER_TENANT_ID;
}

/** Thrown instead of sending a request whose X-Tenant-Id is the placeholder. */
export class TenantNotResolvedError extends Error {
  public readonly name = "TenantNotResolvedError";

  constructor(public readonly path: string) {
    super(TENANT_NOT_RESOLVED_MESSAGE);
  }
}
